<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <!-- Background Hero Layers -->
  <div class="auth-hero-bg position-absolute top-0 start-0 w-100 h-100"></div>
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25"></div>

  <!-- =========================
       CONTENT LAYER
  =========================== -->
  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
           OTP CARD
      =========================== -->
      <div class="
          glass-card glass-card-neon p-4 p-md-5 rounded-4 shadow-sm col-12 col-sm-8 col-md-6 col-lg-5 col-xl-5 mx-auto">

        <!-- Logo -->
        <div class="text-center mb-3">
          <router-link
            to="/"
            class="auth-logo mb-2 text-decoration-none d-inline-block"
            aria-label="Bolide Home"
          ></router-link>
        </div>

        <!-- Heading -->
        <h3 class="mb-1 text-center text-white">
          One Time Pin
        </h3>

        <p class="text-center text-white-50 mb-4 text-sm">
          We've sent a 6-digit security code to
          <br>
          <strong>{{ email }}</strong>
        </p>

        <!-- =========================
             ERROR MESSAGE
        =========================== -->
        <div
          v-if="error_message"
          class="alert alert-danger alert-dismissible fade show rounded-3"
          role="alert"
        >
          {{ error_message }}

          <button
            type="button"
            class="btn-close"
            @click="error_message = ''"
          ></button>

        </div>

        <!-- =========================
             LOADING STATE
        =========================== -->
        <div v-if="is_loading" class="text-center mb-3">

          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>

          <span class="text-white-50">
            Verifying code...
          </span>

        </div>

         <!-- =========================
             OTP FORM
        =========================== -->
        <form v-if="!is_loading" @submit.prevent="submit_otp">

          <!-- OTP INPUTS -->
          <div class="d-flex justify-content-between mb-4 otp-inputs">

            <input
              v-for="(digit,index) in otp"
              :key="index"
              maxlength="1"
              v-model="otp[index]"
              @input="handle_input(index,$event)"
              @paste="handle_paste(index,$event)"
              @keydown.backspace="handle_backspace(index,$event)"
              inputmode="numeric"
              autocomplete="one-time-code"
              class="form-control text-center bg-transparent text-white border-secondary rounded-3 otp-input-box"
            />

          </div>



          <!-- Resend -->
          <p class="text-center text-white-50 text-xs mb-2">

            Didn't receive the code?

            <span
              class="text-primary cursor-pointer"
              @click="resend_otp"
            >
              Resend OTP
            </span>

          </p>

          <!-- Timer -->
          <p class="text-center text-white-50 text-xs mb-0">

            You can resend in

            <strong>
              {{ formatted_timer }}
            </strong>

          </p>

          <!-- Back -->
          <p class="text-center mt-3 mb-0 text-xs">

            <router-link
              to="/login"
              class="text-decoration-none text-white-50"
            >
              ← Back to login
            </router-link>

          </p>

        </form>

      </div>

    </div>
  </div>

</div>